import { ArcElement, Chart as ChartJS } from "chart.js";
ChartJS.register(ArcElement);

import "./ProgressBarChart.css";

const ProgressBarChart = ({ data, fontSize, title }) => {
  return (
    <div style={{ paddingBottom: 2, paddingRight: 10 }}>
      <div
        style={{
          display: "flex",
          gap: 30,
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <div
          style={{
            fontSize: 40,
            fontWeight: "bold",
          }}
        >
          {data}%
        </div>
        <div
          style={{
            fontSize: 15,
            fontWeight: "bold",
          }}
        >
          {title}
        </div>
      </div>
      <div class="progress">
        <div class="progress__bar" style={{ width: `${data}%` }}></div>
      </div>
    </div>
  );
};

export default ProgressBarChart;
